import { render, staticRenderFns } from "./ContributionPostList.vue?vue&type=template&id=52c0a4b5&scoped=true&"
import script from "./ContributionPostList.vue?vue&type=script&lang=js&"
export * from "./ContributionPostList.vue?vue&type=script&lang=js&"
import style0 from "./ContributionPostList.vue?vue&type=style&index=0&id=52c0a4b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c0a4b5",
  null
  
)

export default component.exports